export const APP_ORIGIN_COOKIE_NAME = 'sabal_app_origin';
export const APP_ORIGIN_COOKIE_VALUE = 'web';
